import Vue from 'vue'
import Qs from 'qs'
import {
  Message
} from 'element-ui'
// Vue.use(Message);
Vue.component(Message.name, Message)
import auth from '@/common/auth'
import axios from 'axios'
import router from '../router'
import {rsort} from 'semver'

export const baseURL = '/cm-deals/'
// export const baseURL = "../"
axios.defaults.timeout = 100000
axios.defaults.baseURL = baseURL
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.request.use(
  (config) => {
    config.headers.Authorization =
      'Bearer ' + auth.getSid() || ''
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.code == "401") {
      auth.logout()
      router.push({path: '/login'})
      return
    }
    return response
  },
  (error) => {
    console.log('response ', error)
    // if (error.response && error.response.status) {
    //   // Message.error(error.response.status + ' ' + error.response.statusText)
    //   console.log(error.response.status + ' ' + error.response.statusText)
    // } else {
    //   console.log(error.message||'')
    //   // Message.error(error.message)
    // }
    return Promise.reject(error)
  },
)

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function postForm(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'POST',
      headers: {'content-type': 'application/x-www-form-urlencoded'},
      data: Qs.stringify(data),
      url
    })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, data)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function del(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getXLS(url, data = {}) {
  return axios({
    method: 'get',
    url: url,
    params: data,
    headers: {
      'Content-Type': 'application/octet-stream'
    },
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    const link = document.createElement('a')
    const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    let fileName = res.headers["content-disposition"]
    if (!fileName) {
      fileName = "export_" + new Date().getTime() + ".xlsx"
    } else {
      fileName = fileName.substring(fileName.indexOf("=") + 1)
    }
    link.setAttribute('download', decodeURIComponent(fileName))
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
}

export function getXLSPost(url, data = {}) {
  return axios({
    method: 'POST',
    url: url,
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    const link = document.createElement('a')
    const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    let fileName = res.headers["content-disposition"]
    if (!fileName) {
      fileName = "export_" + new Date().getTime() + ".xlsx"
    } else {
      fileName = fileName.substring(fileName.indexOf("=") + 1)
    }
    link.setAttribute('download', decodeURIComponent(fileName))
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
}

export function getExcelOnline(url, data = {}, fun) {
  axios({
    method: 'get',
    url: url,
    params: data,
    headers: {
      'Content-Type': 'application/octet-stream'
    },
    responseType: 'blob'
  }).then(fun)
}



// WEBPACK FOOTER //
// ./src/service/request.js